<span class="ng-doc-label" *ngIf="label">
	<ng-container *polymorpheusOutlet="label as text">{{ text }}</ng-container>
</span>
<span class="ng-doc-content">
	<ng-content></ng-content>
</span>
